import type { GraphicsSearchResults } from '@components/pages/Graphics/SearchPage/interfaces';
import {
  api_react_v1_graphics_related_path,
  api_react_v1_graphics_search_path,
  api_react_v1_graphics_show_path,
} from '@routes';

import request from './request';

export interface GetGraphicsSearchResultsResponse {
  currentPage: number;
  pageCount: number;
  searchResults: GraphicsSearchResults[];
}

export interface GetGraphicResponse {
  data: {
    commentsCount?: number;
    description: string;
    graphicSource: string;
    height?: number | null;
    id: number;
    imageUrl: string;
    iframe?: string | null;
    isPro: boolean;
    publishDate?: string;
    sourceUrl?: string | null;
    title?: string;
    url?: string;
  };
  success: boolean;
}

export interface GetRelatedGraphicsResponse {
  relatedGraphics: GraphicsSearchResults[];
}

export const GRAPHICS_SEARCH_RESULTS_KEY = 'GRAPHICS_SEARCH_RESULTS';
export const GRAPHICS_KEY = 'GRAPHIC_SHOW';
export const GRAPHICS_RELATED_GRAPHICS_KEY = 'GRAPHICS_RELATED_GRAPHICS';

export async function getGraphicsSearchResults({
  filter,
  limit,
  page,
  query,
}: {
  filter?: string;
  limit: number;
  page: number;
  query: string;
}): Promise<GetGraphicsSearchResultsResponse> {
  const response = await request('post', api_react_v1_graphics_search_path(), {
    filter,
    limit,
    page,
    query,
  });

  if (response.success) {
    return {
      currentPage: response.data.current_page,
      pageCount: response.data.page_count,
      searchResults: response.data.search_results,
    };
  } else {
    throw new Error(response.error);
  }
}

export async function getGraphic(id: number): Promise<GetGraphicResponse> {
  const response = await request('get', api_react_v1_graphics_show_path(id));
  if (response.success) {
    return {
      data: response.data,
      success: true,
    };
  } else {
    throw new Error(response.error);
  }
}

export async function getRelatedGraphics(id: string | number): Promise<GetRelatedGraphicsResponse> {
  const response = await request('get', api_react_v1_graphics_related_path(id));
  if (response.success) {
    return {
      relatedGraphics: response.data.related_graphics,
    };
  } else {
    throw new Error(response.error);
  }
}
